const DISCOVERY_KEYS = new Set([
  "activity",
  "page",
  "view",
  "focus",
  "city",
  "location",
  "open_now",
  "radius_km",
  "lat",
  "lng",
  "location_label",
]);
const UNSAFE_URL_CHARACTERS = /[\\\u0000-\u001f\u007f]/;

function validDiscoveryReturn(
  value: string | null | undefined,
): value is string {
  if (
    !value ||
    value.length > 2048 ||
    UNSAFE_URL_CHARACTERS.test(value) ||
    !/^\/play(?:\?|$)/.test(value)
  )
    return false;
  try {
    const url = new URL(value, "https://player.invalid");
    if (url.pathname !== "/play" || url.hash) return false;
    const seen = new Set<string>();
    for (const [key, item] of url.searchParams) {
      if (
        !DISCOVERY_KEYS.has(key) ||
        seen.has(key) ||
        UNSAFE_URL_CHARACTERS.test(item)
      )
        return false;
      seen.add(key);
    }
    const hasCoordinate =
      url.searchParams.has("lat") || url.searchParams.has("lng");
    if (hasCoordinate) {
      const latitude = Number(url.searchParams.get("lat"));
      const longitude = Number(url.searchParams.get("lng"));
      if (
        !url.searchParams.get("location_label")?.trim() ||
        !url.searchParams.has("radius_km") ||
        url.searchParams.has("city") ||
        !Number.isFinite(latitude) ||
        latitude < -90 ||
        latitude > 90 ||
        !Number.isFinite(longitude) ||
        longitude < -180 ||
        longitude > 180
      )
        return false;
    }
    return true;
  } catch {
    return false;
  }
}

/** URL-carried context survives refresh and the existing authentication return flow. */
export function readFacilityDiscoveryReturn(
  search: string,
): string | undefined {
  const values = new URLSearchParams(search).getAll("discovery");
  return values.length === 1 && validDiscoveryReturn(values[0])
    ? values[0]
    : undefined;
}

export function withFacilityDiscoveryReturn(
  path: string,
  returnTo?: string,
): string {
  if (
    !validDiscoveryReturn(returnTo) ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    UNSAFE_URL_CHARACTERS.test(path)
  )
    return path;
  const target = new URL(path, "https://player.invalid");
  target.searchParams.set("discovery", returnTo);
  return target.pathname + target.search + target.hash;
}
